import { render, staticRenderFns } from "./Allergens.vue?vue&type=template&id=430bea58&scoped=true"
import script from "./Allergens.vue?vue&type=script&lang=js"
export * from "./Allergens.vue?vue&type=script&lang=js"
import style0 from "./Allergens.vue?vue&type=style&index=0&id=430bea58&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "430bea58",
  null
  
)

export default component.exports